import IconClose from 'assets/svg/icons/close.inline.svg';
import IconMenu from 'assets/svg/icons/menu.inline.svg';
import IconLimit from 'assets/svg/limit.inline.svg';
import IconMain from 'assets/svg/main.inline.svg';
import IconSelect from 'assets/svg/selekt.inline.svg';
import IconFactor from 'assets/svg/smart-faktor.inline.svg';
import IconButton from 'components/Atoms/IconButton';
import { routes } from 'constants/routes';
import { Link } from 'gatsby';
import  { HEADER_TYPE } from 'providers/HeaderProvider';
import React from 'react';
import tw, { styled } from 'twin.macro';

const StyledHeader = styled.div`
  ${tw`z-nav fixed top-0 bg-light flex items-center justify-between p-10 h-nav w-full border border-solid border-grey-D`}
`;

export default function Header({ onClickMenu, type, title, withIconMain, withIconSelect, withIconLimit }) {
	return type === HEADER_TYPE.DEFAULT ? (
		<StyledHeader>
			<div className='w-12 h-12 p-12' />
			<div className='flex items-center justify-center'>
				{withIconMain && <IconMain className='w-20 h-20 m-07 fill-current text-tertiary' />}
				{withIconSelect && <IconSelect className='w-20 h-20 m-07 fill-current text-primary' />}
				{withIconLimit && <IconLimit className='w-20 h-20 m-07 fill-current text-tertiary' />}

				{title ? <p className='font-lat font-semibold text-15'>{title}</p> : <IconFactor width='12rem' height='4rem' />}
			</div>
			<IconButton onClick={onClickMenu} Component={IconMenu} size='1.2rem' aria-label="Pokaż menu" />
		</StyledHeader>
	) : (
		<StyledHeader>
			<IconButton component={Link} to={routes.ACADEMY} tw='fill-current stroke-current text-dark p-03 h-24' Component={IconClose} size='1.8rem' />
			<p className='font-lat text-16 ml-07 text-grey-3'>{title}</p>
			<div className='w-18' />
		</StyledHeader>
	);
}
